import classNames from 'classnames';
import * as classes from './TextButton.css';
import { AriaRole, ComponentProps } from 'react';
import BaseTypography from '../BaseTypography';
import { Filter } from '@/types/app.type';

export interface TextButtonProps {
  'data-test-id'?: string;
  /**
   * Define the content of the TextButton.
   * @type string
   * @required
   */
  children: string;
  /**
   * Define the color of the TextButton.
   * @type ComponentProps<typeof BaseTypography>['color'];
   * @optional
   */
  color?: ComponentProps<typeof BaseTypography>['color'];
  /**
   * Define the custom className.
   * @type string
   * @optional
   */
  className?: string;
  /**
   * Define the font size of the TextButton.
   * @type "s" | "m" | "l"
   * @optional
   * @default "m"
   */
  size: 's' | 'm' | 'l';
  /**
   * Define the component type.
   * @type "span" | "p"
   * @optional
   */
  component?: keyof Pick<React.JSX.IntrinsicElements, 'span' | 'p'>;
  /**
   * Define the TextButton role.
   * @type "link" | "presentation" | "none"
   * @optional
   */
  role?: Filter<AriaRole, 'link' | 'presentation' | 'none'>;
}

export function TextButton(props: TextButtonProps) {
  return (
    <BaseTypography
      data-test-id={props['data-test-id']}
      role={props.role ?? 'presentation'}
      component={props.component ?? 'span'}
      color={props.color}
      className={classNames(classes.base, classes.variant[props.size], props.className)}
    >
      {props.children}
    </BaseTypography>
  );
}
